<template>
  <div>
    <vs-table :data="historic">
      <template slot="thead">
        <vs-th> Código </vs-th>
        <vs-th> Motivo </vs-th>
        <vs-th> Data / Hora </vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].id">
            {{ data[indextr].id }}
          </vs-td>

          <vs-td :data="data[indextr].endorsementTypeId">
            {{ data[indextr].endorsementTypeId }}
          </vs-td>

          <vs-td :data="data[indextr].createdAt">
            {{ formatarData(data[indextr].createdAt) }}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>
<script>
import quotationApiService from '../../services/quotation-api';
export default {
  props: ['dadosProposta'],
  watch: {},
  data() {
    return {
      historic: [],
    };
  },
  mounted() {
    this.getHistorico();
  },
  computed: {},
  methods: {
    formatarData(data) {
      const dateObj = new Date(data);
      const dia = dateObj.getDate().toString().padStart(2, '0');
      const mes = (dateObj.getMonth() + 1).toString().padStart(2, '0');
      const ano = dateObj.getFullYear();
      const horas = dateObj.getHours().toString().padStart(2, '0');
      const minutos = dateObj.getMinutes().toString().padStart(2, '0');
      const segundos = dateObj.getSeconds().toString().padStart(2, '0');
      return `${dia}/${mes}/${ano} ${horas}:${minutos}:${segundos}`;
    },
    async getHistorico() {
      this.historic = await quotationApiService.getEndorsementHistory(
        this.dadosProposta.idProposta,
      );
    },
  },
};
</script>
<style scoped></style>
